import { hiIN, teIN } from "@clerk/localizations";

const partial = (t) => ({
  formButtonPrimary: t.cont,
  formFieldLabel__emailAddress: t.email,
  formFieldLabel__password: t.password,
  formFieldInputPlaceholder__emailAddress: t.emailPh,
  formFieldInputPlaceholder__password: t.passwordPh,
  formFieldAction__forgotPassword: t.forgot,
  signIn: {
    start: { title: t.signInTitle, subtitle: t.signInSub, actionText: t.noAccount, actionLink: t.signUp },
    password: { title: t.pwTitle, subtitle: t.pwSub, actionLink: t.other },
  },
  signUp: { start: { title: t.signUpTitle, subtitle: t.signUpSub, actionText: t.haveAccount, actionLink: t.signIn } },
});

const guIN = partial({
  cont: "આગળ વધો", email: "ઈમેલ સરનામું", password: "પાસવર્ડ", emailPh: "તમારું ઈમેલ સરનામું લખો", passwordPh: "તમારો પાસવર્ડ લખો",
  forgot: "પાસવર્ડ ભૂલી ગયા?", signInTitle: "{{applicationName}} માં સાઇન ઇન કરો", signInSub: "ફરી સ્વાગત છે! ચાલુ રાખવા સાઇન ઇન કરો",
  noAccount: "એકાઉન્ટ નથી?", signUp: "સાઇન અપ કરો", pwTitle: "તમારો પાસવર્ડ દાખલ કરો", pwSub: "ચાલુ રાખવા તમારા એકાઉન્ટનો પાસવર્ડ લખો",
  other: "બીજી રીત વાપરો", signUpTitle: "તમારું એકાઉન્ટ બનાવો", signUpSub: "સ્વાગત છે! શરૂ કરવા વિગતો ભરો.", haveAccount: "પહેલેથી એકાઉન્ટ છે?", signIn: "સાઇન ઇન કરો",
});

const mrIN = partial({
  cont: "पुढे जा", email: "ईमेल पत्ता", password: "पासवर्ड", emailPh: "तुमचा ईमेल पत्ता लिहा", passwordPh: "तुमचा पासवर्ड लिहा",
  forgot: "पासवर्ड विसरलात?", signInTitle: "{{applicationName}} मध्ये साइन इन करा", signInSub: "पुन्हा स्वागत आहे! पुढे जाण्यासाठी साइन इन करा",
  noAccount: "खाते नाही?", signUp: "साइन अप करा", pwTitle: "तुमचा पासवर्ड टाका", pwSub: "पुढे जाण्यासाठी तुमच्या खात्याचा पासवर्ड लिहा",
  other: "दुसरी पद्धत वापरा", signUpTitle: "तुमचे खाते तयार करा", signUpSub: "स्वागत आहे! सुरू करण्यासाठी माहिती भरा.", haveAccount: "आधीच खाते आहे?", signIn: "साइन इन करा",
});

export const CLERK_LOCALES = { hi: hiIN, te: teIN, gu: guIN, mr: mrIN };
